import { Outlet, Link } from "react-router-dom";


const HabbitRootPrivacyPolicy = () => {
    return (

        <div style={{ padding: 10 }}>
            <p style={{ fontSize: '21pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{
                    backgroundColor: '#ffffff', fontFamily: 'Arial', fontSize: '21pt', fontWeight: 'bold', display: 'flex',
                    alignItems: 'center',
                }}>
                    <img src="/images/habbit_root_icon.png" alt="Logo" style={{ width: '50px', height: 'auto', borderRadius: '8px', marginRight: '10px' }} />
                    Habbit Root Privacy Policy
                    <div style={{ flexGrow: 1 }}></div>
                    <a href="https://www.buymeacoffee.com/alphay" target="_blank"><img src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png" alt="Buy Me A Coffee" style={{ height: "50px", width: "217px" }} /></a>
                </span>
            </p>
            <p style={{ backgroundColor: '#ffffff', fontSize: '10.5pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{ fontFamily: 'Arial', fontSize: '10.5pt' }}>
                    AlphaY built the Habbit Root app as a Free app. This SERVICE is provided by AlphaY at no cost and is intended for use as is.

                    This page is used to inform visitors regarding my policies with the collection, use, and disclosure of Personal Information if anyone decided to use my Service.

                    If you choose to use my Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that I collect is used for providing and improving the Service. I will not use or share your information with anyone except as described in this Privacy Policy.

                    The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at Habo unless otherwise defined in this Privacy Policy.
                </span>
            </p>


            <span style={{ fontFamily: 'Arial', fontSize: '10.5pt', fontWeight: 'bold' }}>
                Log Data
            </span>
            <p style={{ backgroundColor: '#ffffff', fontSize: '10.5pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{ fontFamily: 'Arial', fontSize: '10.5pt' }}>
                    I want to inform you that whenever you use my Service, in a case of an error in the app I collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing my Service, the time and date of your use of the Service, and other statistics.
                </span>
            </p>



            <span style={{ fontFamily: 'Arial', fontSize: '10.5pt', fontWeight: 'bold' }}>Cookies
            </span>
            <p style={{ backgroundColor: '#ffffff', fontSize: '10.5pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{ fontFamily: 'Arial', fontSize: '10.5pt' }}>
                    Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory.
                    This Service does not use these “cookies” explicitly. However, the app may use third party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.
                </span>
            </p>




            <span style={{ fontFamily: 'Arial', fontSize: '10.5pt', fontWeight: 'bold' }}>Service Providers
            </span>
            <p style={{ backgroundColor: '#ffffff', fontSize: '10.5pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{ fontFamily: 'Arial', fontSize: '10.5pt' }}>
                    I may employ third-party companies and individuals due to the following reasons:

                    To facilitate our Service;
                    To provide the Service on our behalf;
                    To perform Service-related services; or
                    To assist us in analyzing how our Service is used.
                    I want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.
                </span>
            </p>




            <span style={{ fontFamily: 'Arial', fontSize: '10.5pt', fontWeight: 'bold' }}>
                Security
            </span>
            <p style={{ backgroundColor: '#ffffff', fontSize: '10.5pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{ fontFamily: 'Arial', fontSize: '10.5pt' }}>
                    I value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and I cannot guarantee its absolute security.
                </span>
            </p>




            <span style={{ fontFamily: 'Arial', fontSize: '10.5pt', fontWeight: 'bold' }}>
                Links to Other Sites
            </span>
            <p style={{ backgroundColor: '#ffffff', fontSize: '10.5pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{ fontFamily: 'Arial', fontSize: '10.5pt' }}>
                    This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by me. Therefore, I strongly advise you to review the Privacy Policy of these websites. I have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
                </span>
            </p>




            <span style={{ fontFamily: 'Arial', fontSize: '10.5pt', fontWeight: 'bold' }}>
                Children’s Privacy
            </span>
            <p style={{ backgroundColor: '#ffffff', fontSize: '10.5pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{ fontFamily: 'Arial', fontSize: '10.5pt' }}>
                    These Services do not address anyone under the age of 18. I do not knowingly collect personally identifiable information from children under 18. In the case I discover that a child under 8 has provided me with personal information, I immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact me so that I will be able to do necessary actions.
                </span>
            </p>




            <span style={{ fontFamily: 'Arial', fontSize: '10.5pt', fontWeight: 'bold' }}>
                Contact Us
            </span>
            <p style={{ backgroundColor: '#ffffff', fontSize: '10.5pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{ fontFamily: 'Arial', fontSize: '10.5pt' }}>
                    If you have any questions or suggestions about my Privacy Policy, do not hesitate to contact me at alphay28071994@gmail.com.
                </span>
            </p>




            <span style={{ fontFamily: 'Arial', fontSize: '10.5pt', fontWeight: 'bold' }}>
            </span>
            <p style={{ backgroundColor: '#ffffff', fontSize: '10.5pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{ fontFamily: 'Arial', fontSize: '10.5pt' }}>
                </span>
            </p>




            <span style={{ fontFamily: 'Arial', fontSize: '10.5pt', fontWeight: 'bold' }}>
            </span>
            <p style={{ backgroundColor: '#ffffff', fontSize: '10.5pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{ fontFamily: 'Arial', fontSize: '10.5pt' }}>
                </span>
            </p>




            <span style={{ fontFamily: 'Arial', fontSize: '10.5pt', fontWeight: 'bold' }}>
            </span>
            <p style={{ backgroundColor: '#ffffff', fontSize: '10.5pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{ fontFamily: 'Arial', fontSize: '10.5pt' }}>
                </span>
            </p>




            <span style={{ fontFamily: 'Arial', fontSize: '10.5pt', fontWeight: 'bold' }}>
            </span>
            <p style={{ backgroundColor: '#ffffff', fontSize: '10.5pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{ fontFamily: 'Arial', fontSize: '10.5pt' }}>
                </span>
            </p>



            <span style={{ fontFamily: 'Arial', fontSize: '10.5pt', fontWeight: 'bold' }}>
            </span>
            <p style={{ backgroundColor: '#ffffff', fontSize: '10.5pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{ fontFamily: 'Arial', fontSize: '10.5pt' }}>
                </span>
            </p>


            <span style={{ fontFamily: 'Arial', fontSize: '10.5pt', fontWeight: 'bold' }}>
            </span>
            <p style={{ backgroundColor: '#ffffff', fontSize: '10.5pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{ fontFamily: 'Arial', fontSize: '10.5pt' }}>
                </span>
            </p>


            <span style={{ fontFamily: 'Arial', fontSize: '10.5pt', fontWeight: 'bold' }}>
            </span>
            <p style={{ backgroundColor: '#ffffff', fontSize: '10.5pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{ fontFamily: 'Arial', fontSize: '10.5pt' }}>
                </span>
            </p>



            {/* <p style={{ backgroundColor: '#ffffff', fontSize: '10.5pt', lineHeight: '175%', marginBottom: '10pt' }}>
                <span style={{ fontFamily: 'Arial', fontSize: '10.5pt' }}>
                    ********
                </span>
            </p> */}



        </div>
    );
}

export default HabbitRootPrivacyPolicy;
